import { useEffect } from 'react';

// const UTM_EXPIRATION_MS = 2 * 60 * 1000; // 2 minutes to test
const UTM_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

const useCaptureUTM = () => {
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);

        // Check if there are any UTM parameters in the URL
        const hasUTM =
            searchParams.has('utm_source') || searchParams.has('utm_medium') || searchParams.has('utm_campaign') || searchParams.has('gclid');
        const hasFirstSource = searchParams.has('first_source');

        if (hasUTM) {
            const newUTMParams = {
                utm_campaign: searchParams.get('utm_campaign'),
                utm_source: searchParams.get('utm_source'),
                utm_medium: searchParams.get('utm_medium'),
                utm_term: searchParams.get('utm_term'),
                utm_content: searchParams.get('utm_content'),
                first_source: searchParams.get('first_source'),
                _gl: searchParams.get('_gl'),
                _ga: searchParams.get('_ga'),
                gclid: searchParams.get('gclid'),
                expiration: Date.now() + UTM_EXPIRATION_MS,
            };
            localStorage.setItem('utm_params', JSON.stringify(newUTMParams));
        } else if (hasFirstSource) {
            const firstSource = searchParams.get('first_source');
            const newUTMParams = {
                utm_source: firstSource,
                first_source: firstSource,
                expiration: Date.now() + UTM_EXPIRATION_MS,
            };
            localStorage.setItem('utm_params', JSON.stringify(newUTMParams));
        }
        // Retrieve any previously stored UTM params
        const stored = localStorage.getItem('utm_params');
        if (stored) {
            try {
                const parsed = JSON.parse(stored);

                // If the data has expired → remove it
                if (parsed.expiration && parsed.expiration < Date.now()) {
                    localStorage.removeItem('utm_params');
                }
                // If there are new valid UTM parameters → replace the old ones
            } catch {
                // If data is corrupted → clean it up
                localStorage.removeItem('utm_params');
            }
        }
    }, []);
};

export default useCaptureUTM;
